// libs
import React from 'react';

// components
import { Stack, Typography } from '@lyearn/ui';

// types
import { QuizMetricsGridItemProps } from './types';

function QuizMetricsGridItem(props: QuizMetricsGridItemProps) {
  const { iconContainerProps, label, value } = props;

  return (
    <Stack
      alignItems="center"
      className="native:my-4 native:flex-1 native:me-20"
      data-test-id={`${label}-${value}`}
      gapY={8}>
      <iconContainerProps.Icon className="h-20 w-20" fillColorToken="icon-secondary" />
      <Typography className="w-[8.7rem] ms-8" color="text-text-secondary" variant="body-short-01">
        {label}
      </Typography>
      <Typography className="native:ms-8 ms-40" variant="label-01">
        {value}
      </Typography>
    </Stack>
  );
}

export default QuizMetricsGridItem;
